import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "/mnt/f/Users/sGerli/Development/rebble/rebble-store/build/sprite_module.conf.js";
var symbol = new SpriteSymbol({
  "id": "iconSearch",
  "use": "iconSearch-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"iconSearch\">\r\n  <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#fffff\">\r\n    <polygon stroke-width=\"1.5\" points=\"13.157 15.645 15.157 13.645 22 20 20 22\" />\r\n    <polygon stroke-width=\"2\" points=\"2 6.002 6 2 12 2 16 6.002 16 12.017 12 16 6 16 2 12.017\" transform=\"rotate(-20 9 9)\" />\r\n    <polyline points=\"10.5 5 12.5 6 13.5 9\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Search.svg
// module id = 1ofv
// module chunks = 1